import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import {
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { CoreConfigService } from '@core/services/config.service';
import { AuthenticationService } from '../../../../core/service';
import { TranslatePipe } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CoreLoadingScreenService } from '@core/services/loading-screen.service';
import { UserAuthenticatedDTO } from 'app/core/requests/UserAuthenticatedDTO';
import { CompanyLoginDTO } from 'app/core/requests/CompanyLoginDTO';
import { isMobile } from '../../../../core/helpers/constants';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-company-login',
  templateUrl: './company-login.component.html',
  styleUrls: ['./company-login.component.scss'],
  providers: [TranslatePipe],
  encapsulation: ViewEncapsulation.None,
})
export class CompanyLoginComponent implements OnInit, OnDestroy {
  //  Public
  public coreConfig: any;
  public companyLoginForm: FormGroup;
  public loading = false;
  public error = '';
  public passwordTextType: boolean = false;
  private readonly ngUnsubscribe = new Subject();
  public subdomain: string;

  loggedUser: UserAuthenticatedDTO;

  constructor(
    private _router: Router,
    private authenticationService: AuthenticationService,
    private _coreConfigService: CoreConfigService,
    private translate: TranslatePipe,
    private _toastrService: ToastrService,
    private loader: CoreLoadingScreenService,
  ) {
    this.subdomain = localStorage.getItem('currentUserSubdomainMybenefits')
      ? localStorage.getItem('currentUserSubdomainMybenefits')
      : 'default';
    if(this.subdomain && this.subdomain !== 'default'){
      this._router.navigate(['/' + this.subdomain + '/authentication/login']);
    }
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: false,
        },
        customizer: false,
      },
    };

    this.authenticationService.currentUser.subscribe((user) => {
      if (user) {
        this.loggedUser = user;
      }
    });
  }

  /**
   * On init
   */
  ngOnInit(): void {
    this.loader.hide();
    this.companyLoginForm = new FormGroup({
      subdomain: new FormControl('', [Validators.required]),
    });

    // // Subscribe to config changes
    this._coreConfigService.config.subscribe((config) => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.companyLoginForm.controls;
  }

  /**
   * Login
   */
  setCompany() {
    this.loading = true;
    // stop here if form is invalid
    if (this.companyLoginForm.invalid) {
      this.loading = false;
      return;
    }

    // Login
    const params: CompanyLoginDTO = {
      subdomain: this.f.subdomain.value.trim().toLowerCase(),
    };
    this.authenticationService.companyLogin(params).subscribe(
      (response) => {
        this.onCompanyLoginSuccess(params.subdomain);
      },
      (error) => {
        this.onCompanyLoginFail();
      }
    );
  }

  public onCompanyLoginSuccess(subdomain: string) {
    localStorage.setItem('currentUserSubdomainMybenefits', subdomain);
    this._router.navigate(['/' + subdomain + '/authentication/login']);
  }

  public onCompanyLoginFail() {
    this._toastrService.error(
      this.translate.transform('COMPANY_LOGIN.COMPANY_WRONG'),
      this.translate.transform('ERROR'),
      { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
    );
  }

  protected readonly isMobile = isMobile;
  protected readonly environment = environment;

}
